import React, { useRef, useEffect } from "react"
import {
  autresActualites,
  actualiteContainerFirst,
  actualiteContainer,
  autresActualitesResponsiveOnly,
  actualiteCarouselDotsWrapper,
  editButton,
  editButtonFirstActu,
} from "../actualites.module.scss"
import ActuItem from "../ActuItem/actu-item"
import PropTypes from "prop-types"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import MultiCarousel from "react-multi-carousel"
import {
  carouselArrowRight,
  carouselArrowLeft,
} from "../../../Transformers/CarouselTransformer/carousel-transformer.module.scss"
import {
  CustomArrow,
  CustomDot,
} from "../../Carousel/custom-carousel-elements-styled"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"
import { ChangeSlide } from "gatsby-theme-blank/src/components/ChangeSlide/change-slide"

const RenderActualites = ({ actualiteData }) => {
  const carouselResponsiveOnlyRef = useRef(null)
  const carouselRef = useRef(null)

  const changeSlide = (ref) => {
    ChangeSlide(ref)
  }
  const afterChange = () => {
    changeSlide(carouselRef)
  }
  const afterChangeResponsiveOnly = () => {
    changeSlide(carouselResponsiveOnlyRef)
  }

  useEffect(() => {
    if (typeof document !== `undefined`) {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === "childList") {
            mutation.addedNodes.forEach((element) => {
              ChangeSlide(carouselRef)
              ChangeSlide(carouselResponsiveOnlyRef)
            })
          }
        }
      })

      observer.observe(carouselRef.current.containerRef.current, {
        childList: true,
        subtree: true,
      })
    }
  }, [carouselRef, carouselResponsiveOnlyRef])

  const actus = actualiteData
  const firstActu = actus[0].node
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 900 },
      items: 3,
    },
    mobile: {
      breakpoint: { max: 900, min: 0 },
      items: 1,
    },
  }
  return (
    <>
      <>
        <EditButton
          addedClass={editButtonFirstActu}
          link={"/node/" + firstActu.drupal_internal__nid + "/edit"}
        />
        <TransitionFade link={firstActu.path.alias}>
          <ActuItem myClassName={actualiteContainerFirst} actu={firstActu} />
        </TransitionFade>
      </>
      <MultiCarousel
        ref={carouselRef}
        className={autresActualites}
        transitionDuration={500}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        responsive={responsive}
        infinite={true}
        arrows={true}
        autoPlay={false}
        shouldResetAutoplay={false}
        renderButtonGroupOutside={true}
        afterChange={afterChange}
      >
        {actus.slice(1).map(({ node }) => {
          return (
            <>
              <EditButton
                addedClass={editButton}
                link={"/node/" + node.drupal_internal__nid + "/edit"}
              />
              <TransitionFade
                key={node.drupal_id}
                link={node.path.alias}
                tabIndex={"0"}
              >
                <ActuItem myClassName={actualiteContainer} actu={node} />
              </TransitionFade>
            </>
          )
        })}
      </MultiCarousel>
      <MultiCarousel
        ref={carouselResponsiveOnlyRef}
        className={(autresActualites, autresActualitesResponsiveOnly)}
        transitionDuration={500}
        customRightArrow={<CustomRightArrow />}
        customLeftArrow={<CustomLeftArrow />}
        responsive={responsive}
        infinite={true}
        arrows={true}
        autoPlay={false}
        showDots={true}
        customDot={<CustomDots />}
        dotListClass={actualiteCarouselDotsWrapper}
        shouldResetAutoplay={false}
        renderButtonGroupOutside={true}
        afterChange={afterChangeResponsiveOnly}
      >
        {actus.map(({ node, index }) => {
          return (
            <>
              <EditButton
                addedClass={editButton}
                link={"/node/" + node.drupal_internal__nid + "/edit"}
              />
              <TransitionFade
                key={node.drupal_id}
                link={node.path.alias}
                tabIndex={"0"}
              >
                <ActuItem myClassName={actualiteContainer} actu={node} />
              </TransitionFade>
            </>
          )
        })}
      </MultiCarousel>
    </>
  )
}

const CustomRightArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrow
      className={carouselArrowRight}
      onClick={() => onClick()}
      role="button"
      title="Afficher l'image suivante"
    >
      <span aria-hidden="true" data-direction="right"></span>
    </CustomArrow>
  )
}
const CustomLeftArrow = ({ onClick }) => {
  // onMove means if dragging or swiping in progress.
  return (
    <CustomArrow
      className={carouselArrowLeft}
      onClick={() => onClick()}
      role="button"
      title="Afficher l'image précédente"
    >
      <span aria-hidden="true" data-direction="left"></span>
    </CustomArrow>
  )
}

const CustomDots = ({ index, active, onClick }) => {
  return (
    <li data-index={index} className="react-multi-carousel-dot">
      <CustomDot
        index={index}
        data-active={active}
        onClick={() => onClick(index)}
        aria-label={`Aller à la slide ${index + 1}`}
      />
    </li>
  )
}

RenderActualites.propTypes = {
  actualiteData: PropTypes.object.isRequired,
  colors: PropTypes.object,
}

CustomRightArrow.propTypes = {
  onClick: PropTypes.func,
}

CustomLeftArrow.propTypes = {
  onClick: PropTypes.func,
}

CustomDots.propTypes = {
  index: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default RenderActualites
